// [KB-990] Configuración y filtros de GlitchTip (SDK de Sentry). Sin imports de @sentry
// para que se pueda testear en node.

/**
 * DSN del proyecto "enrollment-admin" en GlitchTip. Es público (viaja en el bundle);
 * se puede pisar con VUE_APP_SENTRY_DSN.
 */
export const DEFAULT_SENTRY_DSN = 'https://e705935a66624115826ee5f12e36b5e0@glitchtip.beeverso.org/11';

/**
 * Ruido que no es accionable desde el front: el navegador, navegaciones duplicadas del
 * router y errores de red sin respuesta (el usuario sin conexión o la request abortada).
 */
export const SENTRY_IGNORE_ERRORS: Array<string | RegExp> = [
  /ResizeObserver loop/,
  /The play\(\) request was interrupted/,
  /NavigationDuplicated/,
  /Navigation cancelled from/,
  /^Network Error$/,
  /^Request aborted$/,
  /^timeout of \d+ms exceeded$/,
];

/**
 * Errores HTTP que ya se manejan y no son bugs del front:
 * - 401/403: sesión vencida; el interceptor refresca el token o fuerza el logout.
 * - Sin `response`: sin conexión, request abortada o timeout.
 * - Requests canceladas (axios 0.x marca `__CANCEL__`).
 */
const isHandledHttpError = (error: unknown): boolean => {
  const err = error as {
    isAxiosError?: boolean;
    __CANCEL__?: boolean;
    response?: { status?: number };
  } | null;
  if (!err || typeof err !== 'object') return false;
  if (err.__CANCEL__) return true; // eslint-disable-line no-underscore-dangle
  if (!err.isAxiosError) return false;
  if (!err.response) return true;
  return err.response.status === 401 || err.response.status === 403;
};

export function dropHandledErrors<T>(event: T, hint?: { originalException?: unknown }): T | null {
  return isHandledHttpError(hint?.originalException) ? null : event;
}

/**
 * El build de producción (`pnpm build`) no carga archivo .env, así que sin valor es
 * production. `.env.qa` y `.env.develop` fijan VUE_APP_SENTRY_ENVIRONMENT.
 */
export function resolveSentryEnvironment(configured?: string): string {
  return configured?.trim() || 'production';
}

/** No se inicializa en desarrollo local (`pnpm serve` / `build-develop`). */
export function shouldInitSentry(environment: string, nodeEnv?: string): boolean {
  return environment !== 'development' && nodeEnv !== 'development';
}
